var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Vue2DateRangePicker',{attrs:{"startDate":_vm.start,"endDate":_vm.end,"locale-data":_vm.locale,"opens":_vm.opens,"autoApply":_vm.autoApply,"ranges":_vm.ranges},on:{"update":value => {
            this.$emit('update', value);

            this.start = value.startDate;
            this.end = value.endDate;
        }}},[_c('div',{attrs:{"slot":"input"},slot:"input"},[_vm._t("input",function(){return [_c('vs-button',{attrs:{"color":"primary","type":"flat","icon-pack":"feather","icon":"icon-chevron-down","icon-after":""}},[_vm._v(_vm._s(_vm.rangeText))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }